module.exports = __webpack_public_path__ + "static/media/features-split-image-02.afd82129.png";